import { render, staticRenderFns } from "./DirectSaleGalleryCard.vue?vue&type=template&id=1535e566&scoped=true"
import script from "./DirectSaleGalleryCard.vue?vue&type=script&lang=js"
export * from "./DirectSaleGalleryCard.vue?vue&type=script&lang=js"
import style0 from "./DirectSaleGalleryCard.vue?vue&type=style&index=0&id=1535e566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1535e566",
  null
  
)

export default component.exports